<template>
  <div class="backcover">
    <div class="backcover__innerwrap">
      <div class="backcover__bg"></div>
      <div class="backcover__box">
        <h1 class="backcover__title">{{translations['backcoverTitle']}}</h1>
        <p class="backcover__subtitle" v-html="translations['backcoverText']"></p>
        <ul class="backcover__logos">
          <li class="backcover__logo" v-for="logo in logos"><img :src="logo.image"/></li>
        </ul>
        <a class="backcover__link" :href="link.url">{{link.title}}</a>
        <img class="backcover__main-logo" src="static/svg/logo.svg">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';

export default {
  name: 'backcover',
  components: { PrevNextNav },
  computed: {
    ...mapGetters(['translations', 'page']),
    logos() {
      return this.page.logos;
    },
    link() {
      return this.page.link;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.backcover {
  @include page;

  &__innerwrap {
    background: none;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $c_primary;

    @include not-mobile {
      top: 20px;
      left: 20px;
      right: 20px;
      bottom: 20px;
    }

    @include landscape {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  &__box {
    color: $c_primary;
    text-decoration: none;
    position: absolute;
    left: 20px;
    right: 20px;
    top: 20px;
    background: $c_white;
    box-sizing: border-box;
    padding: 25px 30px;

    @include not-mobile {
      top: auto;
      left: 60px;
      right: 60px;
      bottom: 60px;
    }

    @include landscape {
      left: 20px;
      right: 20px;
      top: 20px;
      bottom: 0;
      display: flex;
      flex-direction: column;
    }

    @include not-tablet {
      left: 40px;
      bottom: 40px;
      right: auto;
      width: 100%;
      max-width: 740px;
    }
  }

  &__title {
    margin: 0 0 20px;
    font-size: 30px;
    font-weight: 600;
    line-height: 1.066;
    font-style: oblique;
    // max-width: 300px;

    @include not-mobile {
      line-height: 1.33;
    }
  }

  &__subtitle {
    margin: 0 0 36px;
    font-size: 14px;
    line-height: 1.15;
    font-weight: 400;
    display: block;

    @include landscape {
      flex-grow: 1;
    }
  }

  &__logos {
    padding: 0;
    margin: 0 0 10px;
    list-style: none;
    display: flex;
    align-items: center;
    max-width: calc(100% - 120px);
    min-height: 105px;

    @include landscape {
      margin: 0;
    }
  }

  &__logo {
    display: inline-block;
  }

  &__link {
    display: block;
    color: $c_black;
    margin: 0;
    font-size: 14px;
    line-height: 1.15;
    font-weight: 400;
    display: block;
    max-width: calc(100% - 120px);
    text-decoration: none;

    @include landscape {
      position: absolute;
      bottom: 25px;
      right: 30px;
    }
  }

  &__main-logo {
    display: none;

    
    @include not-mobile {
      display: block;
      width: 95px;
      position: absolute;
      bottom: 30px;
      right: 30px;
    }

    @include landscape {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Backcover.vue